export default () => ({
  batteryLevelHistory: {},
  editDialog: null,
  followedVehicleKey: null,
  vehicles: {},
  hasInitialized: false,
  vehiclesLoading: false,
  vehiclesLitePromise: false,
  detailedVehicles: {},
  detailedVehiclePromise: null,
  detailedVehiclesLoading: false,
  schedules: {},
  schedulesLoading: false,
  thirtyDayStats: {},
  thirtyDayStatsLoading: false,
  // Maintenance
  accountMaintenanceCategories: [],
  maintenanceHistory: {},
  maintenanceHistoryLoading: false,
  maintenanceReminders: [],
  maintenanceRemindersLoading: false,
});
